<template>
    <form id="onboarding-de" class="wrapper wrapper-tab-form" role="form" method="post" @submit.prevent="submit" novalidate>
        <div>
            <header class="text-centered">
                <span class="new-headline-xlg">Completa la tua registrazione</span>

                <p class="new-text-md">Inserisci il tuo indirizzo email e numero di telefono per continuare.</p>
            </header>

            <form-input-type-email
                name="email"
                label="E-mail"
                :errors="errors.email"
                required
                full-border
            ></form-input-type-email>

            <form-input-type-phone-number
                name="phone"
                label="Numero di telefono"
                :errors="errors.phone"
                phoneCountry="it"
                required
                full-border
            ></form-input-type-phone-number>

            <form-input-type-checkbox
                name="agreements"
                label="Accetto <a href='/informativa-sulla-privacy' target='_blank'>l'informativa sulla privacy</a>."
                :errors="errors.agreements"
                required
            ></form-input-type-checkbox>

            <v-button type="submit" label="Avanti" position="center" full-width></v-button>
        </div>
    </form>
</template>

<script>
    export default {
        props: {
            data: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                errors: {},
            }
        },

        mounted() {
            this.data.meta = JSON.stringify(this.data.meta)
        },

        watch: {
        },

        methods: {
            submit() {
                this.data.email = $("#email").val()
                this.data.phone_country = $('#phone_country').val()
                this.data.phone = $('#phone').val()
                this.data.agreements = $("#agreements").is(":checked")
                this.data.referrer = "lite-it"
                
                axios
                    .post('api/self-invitation', this.data, {
                        headers: {
                            'Accept-Language': 'it'
                        }
                    })
                    .then((e) => {
                        window.dataLayer.push({
                            'event': 'pre_registration_web',
                            'conversion': 'E-mail received'
                        })

                        this.$emit('clicked', e.data)
                    })
                    .catch((e) => {
                        this.errors = e.response.data.errors
                        console.log(e.response)
                        Vuemit.fire('Button--sending-failed', true)
                    })
            }
        }
    }
</script>